var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-marks"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3331 18.8679L15.0578 17.1166L15.6824 17.7499L25.774 7.5L27.5 9.25007L15.6824 21.25L13.3331 18.8679ZM8.18239 17.7499L18.274 7.5L20 9.25007L8.18239 21.25L2.46709 15.4375L4.19308 13.6874L8.18239 17.7499Z",
    fill: "#007b23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarks);
export default __webpack_public_path__ + "static/media/check-marks.eeeb36c70e7da0e7210c8e277c9bfb16.svg";
export { ForwardRef as ReactComponent };